import DataGrid from './BaseDataGrid';

export const BaseDataGrid = DataGrid;
